import { BellOff, Bell } from 'lucide-react'

import { type ToastProps } from '../types'

export const getIconVariant = (iconVariant: ToastProps['iconVariant']) => {
  switch (iconVariant) {
    case 'bell-off':
      return <BellOff color="white" />
    case 'bell':
      return <Bell color="white" />
  }
}
